import { forwardRef } from 'react';
import styled from 'styled-components';

const AnchorEl = styled.a`
    &[aria-disabled='true'] {
        cursor: not-allowed;
    }
`;

const Anchor = forwardRef(({ isDisabled, isLoading, ...props }, ref) => {
    if (!isDisabled) return <AnchorEl {...props} ref={ref} />;

    const { href, ...disabledProps } = props;

    return (
        <AnchorEl
            ref={ref}
            role="link"
            aria-disabled="true"
            {...disabledProps}
        />
    );
});

export default Anchor;
